export type QuestionType =
    | "all"
    | "unused"
    | "incorrect"
    | "correct"
    | "unanswered"
    | "flagged";

export type TestBackground = "qbank" | "usmle" | "nightmode";
export type TestMode = "STUDY" | "TIMED" | "UNTIMED";

export function displayTestMode(mode: TestMode) {
    return {
        STUDY: "Study",
        TIMED: "Timed",
        UNTIMED: "Untimed",
    }[mode] ?? "???";
}

export type CreateTestData = {
    productUuid: string;
    name: string;
    numberOfQuestions: number;
    mode: TestMode;
    categories: number[];
    questionType: QuestionType;
    background: string;
};
